module.exports = __webpack_public_path__ + "static/media/SmartShop_8-568w.038ff0d9.png";